export const h = {		
	login:{		
			login:"تسجيل الدخول",
			pleaseusername:"الرجاء إدخال اسم المستخدم",
			pleasepassword:"الرجاء إدخال كلمة المرور",
			checkname:"الرجاء إدخال اسم المستخدم الصحيح",
			checkpass:"لا يمكن أن تكون كلمة المرور أقل من 3 أحرف",
		},	
	navbar:{	
		home:"الصفحة الأمامية",
		mycenter:"المركز الشخصي",
		outlogin:"يترك",
		close:"إنهاء",
		editLanguage:"لغة التحرير",
	},	
	vip:{	
		nickname:"كنية",
		pleasenickname:"يرجى إدخال اسم مستعار",
		username:"اسم المستخدم",
		pleaseusername:"الرجاء إدخال اسم المستخدم",
		arealogin:"منطقة تسجيل الدخول",
		pleasearealogin:"الرجاء إدخال منطقة تسجيل الدخول الخاصة بك",
		nationality:".بلد المواطنة",
		pleasenationality:"الرجاء تحديد الجنسية",
		depositstatus:"حالة الإيداع",
		pleasedepositstatus:"الرجاء تحديد حالة الإيداع",
		createtime:"وقت الابتكار",
		logintime:"تسجيل الدخول الوقت",
		startime:"وقت البدء",
		endtime:"وقت النهاية",
		no:"رقم سري",
		shangji:"توصية مباشرة للرؤساء",
		keyongmoney:"الرصيد المتوفر",
		baozhengjing:"هامِش",
		fudongyingkui:"الربح والخسارة العائمة",
		zicantotal:"إجمالي الأصول",
		yaoqingma:"شفرة الدعوة",
		zongrujing:"إجمالي الودائع",
		zongchujing:"إجمالي السحوبات",
		loginIp:"تسجيل الدخول الملكية الفكرية",
		zuihoulogin:"آخر وقت لتسجيل الدخول",
		shoucirujingmoney:"مبلغ الإيداع الأول",
		shoucirujingtime:"وقت الإيداع الأول",
		kaitongtime:"وقت مفتوح",
		keyong:"متاح",
		daoshi:"مدرس خاص",
		dongjie:"تجميد",
		chujingstate:"حالة الانسحاب",
		xiajichujingstate:"حالة الانسحاب ذات المستوى الأدنى",
		caozuo:"العمل",
		chakan:"يفحص",
		heji:"المجموع",
		moneytotal:"الرصيد الإجمالي",
		paixu:"نوع",
		daochu:"يصدّر",
		huiyuanguanli:"إدارة الأعضاء",
		yonghu:"مستخدم",
		search:"بحث الاستعلام",
		reset:"إعادة ضبط",
		delete:"يمسح",
		kickout:"طرد",
		notlogin:"لم تقم بتسجيل الدخول",
		editLanguage:"لغة التحرير",
		yourujing:"هناك وديعة",
		wurujing:"لا إيداع",
    juese: "دور",
    xiugaimima: "تغيير كلمة المرور",
    jiumima: "كلمة المرور القديمة",
    shurujiumima: "الرجاء إدخال كلمة المرور القديمة",
    xinmima: "كلمة المرور الجديدة",
    shuruxinmima: "الرجاء إدخال كلمة المرور الجديدة",
    gerenzhongxing: "مركز الشخصي", 
    yonghuxinxi: "معلومات المستخدم",
	remark: "الملاحظات",
	},	
	info:{	
		home:"الصفحة الرئيسية",
		user:"معرف المستخدم",
		nickname:"كنية",
		account:"حساب",
		identity:"رقم الهوية",
		phone:"رقم التليفون",
		nationality:".بلد المواطنة",
		Balance:"إدارة الرصيد",
		real:"حساب حقيقي",
		zhongmongy:"الرصيد الإجمالي",
		keyongmoney:"الرصيد المتوفر",
		jiaoyidongjie:"تم تجميد المعاملة",
		shishilirun:"الربح في الوقت الحقيقي",
		shishikeyong:"متاح في الوقت الحقيقي",
		xunizhanghu:"الحساب الافتراضي",
		churujinguanli:"إدارة الودائع والسحب",
		chakanzijinjilu:"عرض تاريخ الصندوق",
		rujinjilu:"سجل الودائع",
		rujinjine:"قيمة الايداع",
		jiaoyibishu:"عدد المعاملات",
		chujinjilu:"سجلات الانسحاب",
		chujinjine:"كمية السحب",
		jiaoyiguanli:"ادارة العمليات التجارية",
		lishijilu:"سجل التاريخ",
		chakanlishi:"عرض معلومات المعاملات التاريخية",
		jiaoyishoushu:"تداول الكثير",
		jiaoyiyingkui:"تداول الربح والخسارة",
		dangqianchicang:"الموقف الحالى",
		chakandangqianchicang:"عرض معلومات الموقف الحالي",
		dangqianguadan:"الأمر المعلق الحالي",
		chakanguadanliebiao:"عرض قائمة الطلبات المعلقة",
		guadanbishu:"عدد الطلبات المعلقة",
		yongjinguanli:"إدارة اللجنة",
		duanwei:"رتبة",
		wu:"لا أحد",
		zhishushangji:"متفوقة فورية",
		shangjidaili:"وكيل متفوق",
		xiajituandui:"فريق تابع",
		shurudailiname:"الرجاء إدخال اسم الوكيل",
		chakan:"يفحص",
		fanyongjie:"مبلغ الخصم",
		fanyongbishu:"عدد الحسومات",
		chakanyongjinjilu:"عرض سجلات الخصم",
		chakanyonghuinfo:"عرض تفاصيل المستخدم",
		chakanwenjuan:"عرض الاستبيان",
		resetpassword:"إعادة تعيين كلمة المرور",
		sendmsg:"أرسل رسالة",
		update:"يراجع",
		unbound:"غير ملزمة",
		weishiming:"لا توجد مصادقة الاسم الحقيقي",
		gendan:"إدارة التوثيق",
		gensui:"يتبع",
		chakangendan:"عرض سجلات الطلب",
		dingdanhao:"رقم الأمر",
		shoudongpay:"إعادة الشحن اليدوي",
		chakanyongjingjilu:"عرض تاريخ العمولة",
		xiugaiyonghuxinxi:"تعديل معلومات المستخدم",
		queding:"بالتأكيد",
		quxiao:"يلغي",
		email:"بريد",
		selguoji:"الرجاء تحديد الجنسية",
		sendusermsg:"إرسال رسالة إلى المستخدم",
		title:"عنوان",
		shurutitle:"الرجاء إدخال عنوان الرسالة",
		content:"محتوى",
		shurucontent:"الرجاء إدخال محتوى الرسالة",
		zhenshi:"الواقع",
		xuni:"افتراضي",
		fangxiang:"اتجاه",
		zhanghu:"حساب",
		add:"يزيد",
		less:"خصم",
		type:"يكتب",
		guanliyuanpay:"إعادة شحن المسؤول",
		pay:"فوق حتى",
		money:"كمية",
		updategdmsg:"تعديل معلومات الطلب",
		xinhaoyuan:"مصدر الإشارة",
		yes:"نعم",
		no:"لا",
		updateyongjingmsg:"تعديل معلومات العمولة",
		qingxuanzejuese:"الرجاء تحديد دور الحساب",
		zuoduo:"ذهاب لفتره طويلة",
		zuokong:"قصير",
		gensuinicheng:"اتبع اللقب",
		kaicangjia:"سعر الافتتاح",
		pingcangjia:"سعر نهائي",
		shousu:"حجم كبير",
		pingcangdate:"تاريخ فتح الوظيفة",
		kaicangdate:"الموعد النهائي",
		chakangensuiinfo:"عرض تفاصيل المتابعة",
		gensuiuserno:"اتبع رقم المستخدم",
		gensuiyonghuname:"اتبع لقب المستخدم",
		gensuifangshji:"اتبع الطريقة",
		number:"كمية",
		danwei:"وحدة",
		zhengxiang:"إلى الأمام",
		fanxaing:"يعكس",
		beishu:"عديد",
		shousu:"حجم كبير",
		gensuizhuangtai:"متابعة الحالة",
		genjinzhong:"التطبيق هو التالي",
		gensuiok:"توافق على أن تتبع",
		gensuino:"رفض أن يتبع",
		chexiao:"يلغي",
		gensuidate:"اتبع الوقت",
		chakanlishijiaoyi:"عرض معلومات المعاملات التاريخية",
		chakanguadanlist:"عرض قائمة الطلبات المعلقة",
		heyue:"عقد",
		daili:"التمثيل",
		huiyuanname:"اسم الأعضاء",
		xianjia:"حد السعر",
		zhisun:"إيقاف الخسارة",
		guadanjia:"سعر الطلب المعلق",
		zhiyingzhisun:"جني الربح ووقف الخسارة",
		zhiyingjia:"سعر جني الأرباح",
		zhiyinghuichejia:"جني الأرباح سعر الارتداد",
		zhisunjia:"سعر وقف الخسارة",
		zhisunhuichejia:"سعر ارتداد وقف الخسارة",
		weiset:"غير مضبوط",
		zt:"ولاية",
		chakanchicangmsg:"عرض معلومات الموقف الحالي",
		shouyiId:"معرف المستفيد",
		xiajiid:"معرف المستخدم الثانوي",
		xiajiuser:"اسم المستخدم الثانوي",
		fanyongmonney:"مبلغ الخصم",
		tuihuibaozhengjing:"إيداع العودة",
		shouxufei:"رسوم المعالجة",
		shouyi:"دخل",
		lixi:"اهتمام",
		zengmoney:"علاوة",
		zhuijiabaozhengjing:"نداء الهامش",
		fanyong:"الخصم",
		rujing:"إيداع",
		chujing:"سحب الأموال",
		chujingshibai:"استرداد الأموال في حالة فشل مراجعة السحب",
		guanliyuanless:"خصم الاداري",
		pingzhong:"متنوع",
		shengqingzhong:"التقديم",
		wancheng:"ينهي",
		chongzhimima:"تمت إعادة تعيين كلمة المرور بنجاح",
		copy:"ينسخ",
		zhanghaomima:"كلمة مرور الحساب",
		fenye:"المقالة / الصفحة",
    tixianmima:"استخراج كلمة السر",
		gong:"شائع",
		tiao:"يجرد",
		ye:"صفحة",
		goto:"اذهب إلى",
		outtitle:"لقد تم تسجيل خروجك، يمكنك الإلغاء والبقاء في هذه الصفحة أو تسجيل الدخول مرة أخرى.",
		outok:"موافق لتسجيل الخروج",
		chongxingdenglu:"إعادة التسجيل",
		cancel:"يلغي",
		pingtai:"منصة",
		nodata:"لايوجد بيانات",
    shangjiID: "معرّف رفيع",
    shangjiaccount: "حساب رفيع",
    shangjiname: "اسم مستعار رفيع",
    shangjinickname: "اسم رفيع",
    zhongyingkui: "إجمالي الربح والخسارة",
    fuying: "ربح عائم",
    yue: "الرصيد",
    sheng: "ترتيب صاعد",
    jiang: "ترتيب نزول"
	},	
	history:{		
			guadan:"الربح والخسارة",
			shijia:"طلب معلق",
			gendan:"سعر السوق",
			dangqianjia:"اتبع أوامر",
			geyelixi:"السعر الحالي",
			weituodate:"الفائدة بين عشية وضحاها",
			pingcangfangshi:"وقت اللجنة",
			dingdanyongjing:"طريقة الإغلاق",
			shoudongpingcang:"عمولة الطلب",
			qiangzhipingcang:"الإغلاق اليدوي",
			gendanpingcang:"التصفية القسرية",
			baocang:"التصفية",
			yuguqiangpingjia:"اتبع الأوامر لإغلاق المركز",
			kaicangdiqu:"سعر التكافؤ القسري المقدر",
			ispingcang:"منطقة الافتتاح",
			tips:"هل أنت متأكد من التصفية القسرية؟",
			pincangsucc:"تَلمِيح",
			queding:"تم إغلاق المركز بنجاح",
			cancel:"بالتأكيد",
		},	

	Langswitch: {	
	  "en":"إنجليزي",	
	  "id":"الاندونيسية",	
	  "th":"اللغة التايلاندية",	
	  "vi":"الفيتنامية",	
	  "zh":"صينى",	
	  "fa":"فرنسي",	
	  "han":"الكورية",	
	  "tu":"اللغة التركية",	
	  "pu":"البرتغالية",	
	  "xi":"الأسبانية",	
	  "jp":"اليابانية",	
	  "ar":"عربي",	
	},	
}		



// WEBPACK FOOTER //
// ./src/i18n/langs/ar.js